module.exports = __webpack_public_path__ + "static/media/CJ2.3282992b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/strategy/data/CJ2.gif
// module id = 195
// module chunks = 0